import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'

import MobileMenu from '../../components/MobileMenu'
import Header from '../../components/Header'
import { ToastContainer } from 'react-toastify';
import TableListMercadoLivre from '../../components/TableListMercadoLivre'
import Filter from '../../components/Filter'
import ModalFacebook from '../../components/ModalFacebook'
import { PostsContext } from '../../context/posts'
import FooterMercadoLivre from '../../components/FooterMercadoLivre';
import DashboardGrafical from '../../components/DashboardGrafical'
import { MercadoLivreContext } from '../../context/mercadoLivre'


const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){
        width: 100%;
        flex-direction: column;
    }

`

const MercadoLivre = () => {
    const {products,getProductsByName} = useContext(MercadoLivreContext)
    const { getByName } = useContext(PostsContext)

    const clientId = '5298514251293487'; // Coloque seu client ID aqui
    const redirectUri = 'https://backoffice-tkg-engates.onrender.com/dashboard/mercadolivre'; // A URL de retorno após o login
    const scope = 'write'; // O escopo de permissões, você pode ajustar conforme necessário
    const authUrl = `https://auth.mercadolivre.com.br/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;

    const handleClick = () => {
        // Redireciona o usuário para a página de login do Mercado Livre
        window.location.href = authUrl;
    };
    const [data] = useState([
        {
            name: "Imagem"
        },
        {
            name: "Nome"
        },
        {
            name: "Preço"
        },
        {
            name: "Qtd Estoque"
        }
    ])
    const [modalShow, setModalShow] = useState(false)

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper id='up'>

                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name={"Mercado Livre"} />
                    <Filter buttonName={"Nova conta"} onChange={(e) => getProductsByName(e.target.value)} onClick={() => handleClick()} type={1} />

                    <RowDashboard>
                        <DashboardGrafical type={1} value={products.length} width={"27%"} name="Total de produtos" />
                    </RowDashboard>
                    <TableListMercadoLivre structure={data} />
                </div>

                <MobileMenu />
                <ModalFacebook
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
                <FooterMercadoLivre value={products.length} />
            </CardWrapper>
        </motion.div>

    )
}

export default MercadoLivre